import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const InfoToast = (text) => {
  toast.info(text);
};
